import {useLocalStorage} from "react-use-storage";
import {languagesList} from "../../PageValues";

export type LanguageCode = 'pl' | 'en'

/**
 * Language is persisted in local storage and read by i18next on boot, so a
 * switch needs a reload to re-fetch the translation bundle.
 */
const useLanguage = () => {

    const [language, setLanguage] = useLocalStorage<LanguageCode>('language', 'pl')

    const changeLanguage = (next: string) => {
        if (next === language) {
            return
        }
        setLanguage(next as LanguageCode)
        window.location.reload()
    }

    return ({
        language: (language ?? 'pl') as LanguageCode,
        languages: languagesList,
        changeLanguage
    })
}

export default useLanguage
